/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Role_TargetInputs */

const en_us2_exercise_role_target = /** @type {(inputs: Exercise_Role_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target`)
};

const pt_br2_exercise_role_target = /** @type {(inputs: Exercise_Role_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alvo`)
};

const es_419_exercise_role_target = /** @type {(inputs: Exercise_Role_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

const pt_pt2_exercise_role_target = /** @type {(inputs: Exercise_Role_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alvo`)
};

const fr_fr2_exercise_role_target = /** @type {(inputs: Exercise_Role_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cible`)
};

const de_de2_exercise_role_target = /** @type {(inputs: Exercise_Role_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel`)
};

const it_it2_exercise_role_target = /** @type {(inputs: Exercise_Role_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principale`)
};

/**
* | output |
* | --- |
* | "Target" |
*
* @param {Exercise_Role_TargetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_role_target = /** @type {((inputs?: Exercise_Role_TargetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Role_TargetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_role_target(inputs)
	if (locale === "es-419") return es_419_exercise_role_target(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_role_target(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_role_target(inputs)
	if (locale === "de-DE") return de_de2_exercise_role_target(inputs)
	if (locale === "it-IT") return it_it2_exercise_role_target(inputs)
	return en_us2_exercise_role_target(inputs)
});
export { exercise_role_target as "exercise.role_target" }